function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 255.997,
  cy: 256,
  r: 255.997,
  style: {
    fill: "#41b4e6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M512 256.003c0-6.238-.235-12.419-.673-18.546L405.228 131.36 106.772 248.759l114.191 114.192 1.498 5.392 1.939-1.955.008.008-1.947 1.947L348.778 494.66C444.298 457.5 512 364.663 512 256.003",
  style: {
    fill: "#0091c8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m231.138 293.3 115.691 87.347 58.399-249.287-298.457 117.399 90.817 30.081 165.743-111.176z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m197.588 278.84 24.873 89.504 8.677-75.044 132.193-125.636z",
  style: {
    fill: "#d2d2d7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m268.738 321.688-46.277 46.656 8.677-75.044z",
  style: {
    fill: "#b9b9be"
  }
}));
export default SvgTelegram;